export const EXPRESS_INTEREST_STAGE = 1;
export const CREATE_ACCOUNT_STAGE = 2;
export const SHARE_INVESTOR_QUALIFICATION_STAGE = 3;
